var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-form-generator',{ref:'vfg',attrs:{"tag":"div","schema":_vm.formSchema.pages[0].schema,"model":_vm.formSchema.model,"options":_vm.formSchema.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }